import { useState } from "react";
import { useIntl } from "react-intl";
import { isValidEmail } from "../../../../js/helper";


const EmailCustomField = ({ field, editingFieldId, setEditingFieldId, updateField }) => {
    const intl = useIntl();
    const [localValue, setLocalValue] = useState(field?.value || '');
    const [emailError, setEmailError] = useState('');

    const validEmail = isValidEmail(field?.value);
    const isEditing = editingFieldId === field._id;

    const handleBlur = () => {
        if (localValue && !isValidEmail(localValue)) {
            setEmailError('Please enter a valid email address.');
            return;
        }
        setEmailError('');
        updateField(field._id, localValue);
        setEditingFieldId(false);
    };

    return (
        <div
            className={`flex flex-col w-full cursor-text rounded-r ${isEditing ? 'bg-indigo-50/40' : 'hover:bg-indigo-50/50'}`}
            style={{ padding: '8px 12px', minHeight: 40 }}
            onClick={() => {
                if (!isEditing) { setLocalValue(field?.value || ''); setEditingFieldId(field._id); }
            }}
        >
            {isEditing ? (
                <>
                <input
                    className="w-full outline-none border-none bg-transparent text-[13px]"
                    style={{ color: emailError ? 'rgba(220,38,38,0.85)' : 'rgba(15,15,25,0.8)' }}
                    value={localValue}
                    type="text"
                    placeholder={intl.formatMessage(
                        { id: 'ENTER_FIELD', defaultMessage: 'Enter {field}' },
                        { field: intl.formatMessage({ id: `${field?.name}`.replaceAll(' ', '_').toUpperCase(), defaultMessage: field?.name }) }
                    )}
                    onChange={(e) => { setLocalValue(e.target.value); setEmailError(''); }}
                    autoFocus
                    onBlur={handleBlur}
                />
                {emailError && (
                    <div className="text-[11px] mt-0.5" style={{ color: 'rgba(220,38,38,0.85)' }}>{emailError}</div>
                )}
                </>
            ) : validEmail ? (
                <a
                    href={`mailto:${field?.value}`}
                    className="cursor-pointer underline text-[13px] text-[#3B82F6] truncate"
                    onClick={(e) => e.stopPropagation()}
                >
                    {field?.value}
                </a>
            ) : (
                <span className="text-[13px]" style={{ color: field?.value ? 'rgba(15,15,25,0.8)' : 'rgba(15,15,25,0.28)' }}>{field?.value || 'Empty'}</span>
            )}
        </div>
    );
};

export default EmailCustomField;
